__turbopack_context__.v({
  "heading": "styles-module-scss-module__0sFJga__heading",
  "market_summary": "styles-module-scss-module__0sFJga__market_summary",
  "summary_text": "styles-module-scss-module__0sFJga__summary_text",
});
